module.exports = __webpack_public_path__ + "static/media/cerdolomo.92dcb717.jpg";